import { Collapse, Colors } from "@blueprintjs/core";

import { Box, Flex } from "@/components/layout/flexbox";
import { Avatar } from "@/components/pieces/users/Avatar";
import { STANDARD_NAV_HEIGHT } from "@/css/constants";
import { CustomerUser, RoleView } from "@/types/users";

import { ClientIntakeForm } from "./ClientIntakeForm";
import { ClientDetail } from "./client_detail";
import { ClientNotes } from "./client_notes";
import { ToggleButton } from "./pieces/ToggleButton";

interface ProfileSidebarProps {
  loading: boolean;
  user: CustomerUser;
  notesVisible: boolean;
  detailsVisible: boolean;
  intakeFormVisible: boolean;
  mobile: boolean;
  view?: RoleView;
  setNotesVisible: (visible: boolean) => void;
  setDetailsVisible: (visible: boolean) => void;
  setIntakeFormVisible: (visible: boolean) => void;
}

export function ProfileSidebar({
  loading,
  user,
  notesVisible,
  detailsVisible,
  intakeFormVisible,
  mobile,
  view = "coach",
  setNotesVisible,
  setDetailsVisible,
  setIntakeFormVisible,
}: ProfileSidebarProps) {
  return (
    <Box
      style={{
        background: Colors.WHITE,
        borderLeft: mobile ? "0" : `1px solid ${Colors.LIGHT_GRAY3}`,
        flexBasis: mobile ? "initial" : "480px",
      }}
    >
      <Box
        style={
          mobile
            ? {}
            : {
                position: "sticky",
                top: `${STANDARD_NAV_HEIGHT}px`,
                height: `calc(100vh - ${STANDARD_NAV_HEIGHT}px)`,
                overflowY: "scroll",
              }
        }
      >
        <Flex
          p={[3, 3, 24]}
          flexDirection="column"
          style={{
            borderBottom: `1px solid ${Colors.LIGHT_GRAY3}`,
          }}
        >
          <Box>
            <Avatar user={user} size={75} />
          </Box>
          <Box
            mt={1}
            style={{
              fontWeight: 600,
              fontSize: "24px",
              lineHeight: "36px",
            }}
          >
            {user.name}
          </Box>
        </Flex>
        <Flex p={[3, 3, 24]} flexDirection="column">
          <Box>
            <ToggleButton
              onClick={() => {
                setDetailsVisible(!detailsVisible);
              }}
              minimal={true}
              rightIcon={detailsVisible ? "chevron-down" : "chevron-up"}
            >
              DETAIL
            </ToggleButton>
          </Box>
          <Box style={{ position: "relative", overflow: "hidden" }}>
            <Collapse isOpen={detailsVisible}>
              <Box p={2}>
                <ClientDetail user={user} />
              </Box>
            </Collapse>
          </Box>
        </Flex>
        {!loading && user.intakeForm && view === "coach" ? (
          <Flex
            p={[3, 3, 24]}
            flexDirection="column"
            style={{
              borderTop: `1px solid ${Colors.LIGHT_GRAY3}`,
            }}
          >
            <Box>
              <ToggleButton
                minimal={true}
                onClick={() => {
                  setIntakeFormVisible(!intakeFormVisible);
                }}
                rightIcon={intakeFormVisible ? "chevron-down" : "chevron-up"}
              >
                INTAKE FORM
              </ToggleButton>
            </Box>
            <Box style={{ position: "relative", overflow: "hidden" }}>
              <Collapse isOpen={intakeFormVisible}>
                <Box p={2}>
                  <ClientIntakeForm intakeForm={user.intakeForm} />
                </Box>
              </Collapse>
            </Box>
          </Flex>
        ) : null}
        {view === "coach" && (
          <Flex
            p={[3, 3, 24]}
            flexDirection="column"
            style={{
              borderTop: `1px solid ${Colors.LIGHT_GRAY3}`,
            }}
          >
            <Box>
              <ToggleButton
                minimal={true}
                onClick={() => {
                  setNotesVisible(!notesVisible);
                }}
                rightIcon={notesVisible ? "chevron-down" : "chevron-up"}
              >
                MY NOTES
              </ToggleButton>
            </Box>
            <Box style={{ position: "relative", overflow: "hidden" }}>
              <Collapse isOpen={notesVisible}>
                <ClientNotes user={user} loading={loading} />
              </Collapse>
            </Box>
          </Flex>
        )}
      </Box>
    </Box>
  );
}
